var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discount-tag"},[_c('span',[_vm._v("Up to "+_vm._s(_vm.discount)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }